export default __webpack_public_path__ + "static/media/midasi_point_vi_pc@2x.35bff6f6.png";